import jwt from 'jsonwebtoken';
import store from '../store';

export default {
  retrieveToken() {
    return localStorage.getItem('token');
  },
  setUserData(token) {
    token = token || this.retrieveToken();

    // Initialize authentication variable
    let authData = {
      loggedIn: false,
      token: '',
      exp: 0,
    };

    if (token) {
      // decode token to retrieve expiry
      const decoded = jwt.decode(token);

      // Set authentication variable to logged in
      authData = {
        loggedIn: true,
        token,
        exp: decoded.exp,
      };

      delete decoded.iat;
      delete decoded.exp;

      store.commit('userDataState', decoded);
    }

    store.commit('authState', authData);

    return authData;
  },
  saveToken(token = '') {
    localStorage.setItem('token', token);

    // Commit token to state
    let authData = {
      loggedIn: false,
      token: '',
      exp: 0,
    };
    let decoded = {};

    if (token !== '') {
      // decode token to retrieve expiry
      try {
        decoded = jwt.decode(token);
      } catch (err) {
        return false;
      }

      authData = {
        loggedIn: true,
        token,
        exp: decoded.exp,
        // resources:
      };
    }

    store.commit('authState', authData);

    delete decoded.iat;
    delete decoded.exp;
    store.commit('userDataState', decoded);

    return true;
  },
  unsetToken() {
    localStorage.removeItem('token');

    // unset token to state
    const authData = {
      loggedIn: false,
      token: null,
      exp: 0,
    };

    store.commit('authState', authData);
  },
};
